module.exports = __webpack_public_path__ + "static/media/level-three.e67e9d6d.svg";